import { addClusteredPins, removeClusteredPins } from './clustered_pins';
import { addPreviewLines } from './preview_lines';
import { getAlgoliaIndex } from '../../search';
import { SearchFiltersUtil } from '../../search_filters_util';
import { addResultsHeatmapOverlay, heatmapOverlayId } from './heatmap';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';
const pendingLayerId = 'pendingTrails';
const clusterLayerId = 'clusterTrails';

const addPendingTrails = (map, trailId, renderHoverCard, layerId, color, enabledOverlays) => {
  return getAlgoliaIndex(StringConstantsMixin.constants.ALGOLIA.PENDING_INDEX)
    .search('', SearchFiltersUtil.createAlgoliaTrailsObject(map))
    .then(content => {
      const results = content.hits.filter(trail => {
        // Do not show pin of current trail if we are looking at one
        if (trailId && trail.ID == trailId) {
          return false;
        }
        const machineSource = trail.source === 1046;
        return layerId === clusterLayerId ? machineSource : !machineSource;
      });
      results.forEach(trail => {
        trail.name += ' (Pending)';
      });
      addPreviewLines(map);
      addClusteredPins(map, layerId, results, color, renderHoverCard, 0.6);
      if (layerId === pendingLayerId && enabledOverlays.includes(heatmapOverlayId(layerId))) {
        addResultsHeatmapOverlay(map, layerId, results, enabledOverlays, renderHoverCard);
      }
    });
};

const removePendingTrails = (map, layerId) => {
  removeClusteredPins(map, layerId);
};

export { addPendingTrails, removePendingTrails };
